import { appointmentTypeBaseModel } from './crud';

export * from './types';

export const useAppointmentTypesById = appointmentTypeBaseModel.fetchById();
export const useAppointmentTypesByIds = appointmentTypeBaseModel.fetchByIds();
export const useAppointmentTypesMany = appointmentTypeBaseModel.fetchMany();
export const useAppointmentTypesManyInfiniteQuery =
  appointmentTypeBaseModel.fetchPaginated();
export const useAppointmentTypesUpdateOne = appointmentTypeBaseModel.edit();
export const useAppointmentTypesCreateOne = appointmentTypeBaseModel.create();
export const useAppointmentTypesRemoveOne = appointmentTypeBaseModel.delete();
export const useAppointmentTypesRemoveByIds =
  appointmentTypeBaseModel.deleteByIds();

export const useAppointmentTypesByIdV2 = appointmentTypeBaseModel.fetchByIdV2();
export const useAppointmentTypesByIdsV2 =
  appointmentTypeBaseModel.fetchByIdsV2();
export const useAppointmentTypesManyV2 = appointmentTypeBaseModel.fetchManyV2();
export const useAppointmentTypesManyInfiniteQueryV2 =
  appointmentTypeBaseModel.fetchPaginatedV2();
export const useAppointmentTypesUpdateOneV2 = appointmentTypeBaseModel.editV2();
export const useAppointmentTypesCreateOneV2 =
  appointmentTypeBaseModel.createV2();
export const useAppointmentTypesRemoveOneV2 =
  appointmentTypeBaseModel.deleteV2();
export const useAppointmentTypesRemoveByIdsV2 =
  appointmentTypeBaseModel.deleteByIdsV2();

// New names based on Mongoose queries

export const useAppointmentTypeById = appointmentTypeBaseModel.fetchById();
export const useAppointmentTypeByIds = appointmentTypeBaseModel.fetchByIds();
export const useAppointmentTypeMany = appointmentTypeBaseModel.fetchMany();
export const useAppointmentTypeCount = appointmentTypeBaseModel.count();
export const useAppointmentTypePagination =
  appointmentTypeBaseModel.fetchPaginated();
export const useAppointmentTypeUpdateOne = appointmentTypeBaseModel.edit();
export const useAppointmentTypeCreateOne = appointmentTypeBaseModel.create();
export const useAppointmentTypeRemoveOne = appointmentTypeBaseModel.delete();
export const useAppointmentTypeRemoveByIds =
  appointmentTypeBaseModel.deleteByIds();

export const useAppointmentTypeByIdV2 = appointmentTypeBaseModel.fetchByIdV2();
export const useAppointmentTypeByIdsV2 =
  appointmentTypeBaseModel.fetchByIdsV2();
export const useAppointmentTypeManyV2 = appointmentTypeBaseModel.fetchManyV2();
export const useAppointmentTypeCountV2 = appointmentTypeBaseModel.countV2();
export const useAppointmentTypePaginationV2 =
  appointmentTypeBaseModel.fetchPaginatedV2();
export const useAppointmentTypeUpdateOneV2 = appointmentTypeBaseModel.editV2();
export const useAppointmentTypeCreateOneV2 =
  appointmentTypeBaseModel.createV2();
export const useAppointmentTypeRemoveOneV2 =
  appointmentTypeBaseModel.deleteV2();
export const useAppointmentTypeRemoveByIdsV2 =
  appointmentTypeBaseModel.deleteByIdsV2();
export const useAppointmentTypeManyByContentRangeV2 =
  appointmentTypeBaseModel.fetchManyByContentRangeV2();
